'use client';
import { ComponentType } from 'react';
import { Props as NewsletterSubscribeProps } from './newsletter-subscribe.component';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import dynamic from 'next/dynamic';

const DynamicNewsletterSubscribeComponent: ComponentType<NewsletterSubscribeProps> = dynamic(
  () => import('./newsletter-subscribe.component')
);

export default DynamicNewsletterSubscribeComponent;

export function calculateNewsletterSubscribePlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 210 },
    { sinceWidth: 768, height: 230 },
    { sinceWidth: 1024, height: 605 }
  ];

  return {
    heightSinceWidth
  };
}
